const template = require('./client_profile_changes_show.html.slim')
declare var angular
import { diffKeys } from 'lodash'

export class ClientProfileChangesShow {
  static $inject = [
    '$routeParams',
    '$window',
    'Comment',
    'ClientProfileChanges',
    'InvestmentAccount'
  ]

  public clientProfileChange: any
  public changes:             string[]
  public comments:            any[] = []
  public commentError:        any
  public newComment:          any
  public newCommentError:     any
  public approveError:     string
  public accounts

  private profileId: number
  private addCommentWait: boolean = false
  private saveCommentWait: boolean = false
  private commentResource
  private clientProfileChangeResource
  private window

  private _archived:          boolean = false

  constructor(
    private $routeParams,
    private $window,
    private Comment,
    private ClientProfileChanges,
    private InvestmentAccount
  ) {
    this.profileId = this.$routeParams.id
    this.window = $window

    this.commentResource = Comment
    this.clientProfileChangeResource = ClientProfileChanges

    ClientProfileChanges.get({
      id: this.$routeParams.id
    }, (cpc) => {
      this.changes = diffKeys(cpc.previousProperties, cpc.currentProperties)
      this.clientProfileChange = cpc
      this._archived = this.clientProfileChange.archived

      InvestmentAccount.get({
        userId: cpc.clientId
      }, (accounts) => {
        this.accounts = accounts.data
      })
    })

    this.loadComments()
  }

  get archived(): boolean { return this._archived }
  set archived(value) {
    if (value === true) {
      this.clientProfileChangeResource.delete({
        id: this.profileId,
        updatedAt: this.clientProfileChange.updatedAt,
      }).$promise.then(() => {
        this._archived = true
        this.window.history.back() 
      }).catch((e) => {
        if (e.data.message === 'ERROR_OUT_OF_DATE') {
          this.approveError = 'Client has updated their profile since you loaded this page. Please reload the page to see the most up-to-date changes.'
        } else {
          this.approveError = e.data.message
        }
      })
    } else if (value === false) {
      this.clientProfileChangeResource.update({
        id: this.profileId,
        archived: false,
      }).$promise.then(() => {
        this._archived = false
        this.window.history.back()
      }).catch((e) => {
        this.approveError = e.data
      })
    }
  }

  /**
   * Archive the client profile change (set archived to true)
   */
  public archive(): void {
    this.archived = true
  }

  /**
   * Restore the client profile change (set archived to false)
   */
  public restore(): void {
    this.archived = false
  }

  /**
   * Add a comment to this client profile change
   */
  public addComment(): void {
    if (!this.addCommentWait) {
      this.addCommentWait = true
      this.clientProfileChangeResource.addComment({
        id: this.profileId,
        content: this.newComment,
      }).$promise.then( (comment) => {
        this.newComment = null
        this.comments.push(comment)
      }).catch( (e) => {
        this.newCommentError = e.data
      }).finally( () => {
        this.addCommentWait = false
      })
    }
  }

  /**
   * Edit a comment
   * @param {Object} comment A comment object
   */
  public editComment(comment): void {
    for (var c of this.comments) {
      c.isEditing = false
    }
    comment.isEditing = true
  }

  /**
   * Save a comment that has been edited
   * @param {Object} comment A comment object
   */
  public saveComment(comment): void {
    if (!this.saveCommentWait) {
      this.saveCommentWait = true
      this.commentResource.update(comment).$promise.then( (updatedComment) => {
        Object.assign(comment, updatedComment)
        comment.isEditing = false
      }).catch( (e) => {
        this.commentError = e.data
      }).finally( () => {
        this.saveCommentWait = false
      })
    }
  }

  public deleteComment(comment): void {
    this.commentResource.delete(comment, () => {
      this.loadComments()
    })
  }

  private loadComments(): void {
    this.clientProfileChangeResource.getComments({
      id: this.profileId
    }, (comments) => {
      this.comments = comments;
    })
  }
}

angular.module('wbComponents').directive('clientProfileChangesShow', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: ClientProfileChangesShow,
    controllerAs: 'ctrl',
    bindToController: true,
  }
})
